module.exports = "/legacy/3b2d6c6a529c0766ca2e754bbf006255.png";